const ROUTES = {
    // PERSONAL : '/personal',
    REGISTRATION: '/registration',
    ABOUT: '/about',
    CONTACT: '/contact-us',
    HOME: '/',
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgotpassword',
    ACCOUNTDETAIL: '/registration',
    CONTACTDETAIL: '/contact-detail',
    COMPANY_LIST: '/members',
    RESET_PASSWORD: '/resetpassword',
    REG_SUCCESS: '/registration-success',
    OUR_GELLARY: "/event-highlights",
    FIND_BUYER_AND_SUPPLIER: "/find-buyer-supplier",
    CONSTRUCTION: "/construction",
    MAINTENANCE: "/maintenance",
    TERMS_OF_SERVICE: "/terms-and-conditions",
    TERMS_OF_SERVICE_SUPPLIER: "/terms-and-conditions-supplier",
    TERMS_OF_SERVICE_BUYER: "/terms-and-conditions-buyer",
    TERMS_OF_SERVICE_LOGISTICS: "/terms-and-conditions-logistic",
    InquiryUs: "/inquiry",
    LANDING_PAGE: "/landing/:id",
    PARTNER_PAGE: "/partner/:id",
    LOGISTIC_PARTNER_DETAILS: "/logistic-partner-details",
    LOGISTIC_MEMBERS: "/logistics-members",
    FIND_LOGISTIC_PARTNER: "/search-partner",
    LOGISTIC_PARTNER: "/logistic-partner",
    NO_LANDING_PAGE: "/no-landing",
    REGISTRATION_V2: '/registration/v2',
};

export default ROUTES;
